<template>
  <BootGate>
    <router-view />
  </BootGate>

  <SwitchingOverlay
    v-model="isSwitching"
    :organization="switchingOrganization"
  />

  <VueQueryDevtools v-if="showQueryDevtools" button-position="bottom-left" />
</template>

<script setup lang="ts">
import { watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { VueQueryDevtools } from '@tanstack/vue-query-devtools'
import { SwitchingOverlay, useOrganizationSwitcher } from '@/apps/organizations'
import { useThemeStore } from '@/apps/core'
import BootGate from '@/apps/session/components/BootGate.vue'
import { setPlayerLocale } from '@/players/common/locale'

const router = useRouter()
const { isSwitching, switchingOrganization, installRouterHook } = useOrganizationSwitcher()

installRouterHook(router)

// The theme is the shell's, not a layout's: applied here, a screen outside the app layout — the
// sign-in, the organization list — opens in the chosen theme instead of light until the layout
// first mounts.
useThemeStore().initTheme()

// The query inspector's floating button sits over the screen's bottom-left corner, so it is
// opt-in rather than on for every `bun run dev` (.env.example).
const showQueryDevtools = import.meta.env.DEV && import.meta.env.VITE_QUERY_DEVTOOLS === '1'

// Bridge the app's active language to the standalone players, which are
// decoupled from vue-i18n and otherwise default to the browser language. This
// single sync covers every in-app player (the player locale is a shared
// singleton), so a user whose app is in French but whose browser is in English
// still gets French player controls.
const { locale } = useI18n()
watch(locale, (value) => setPlayerLocale(value), { immediate: true })
</script>
